module.exports = __webpack_public_path__ + "img/close-lg.dfe815af.svg";